import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { reportService } from '../../services/reportService';

export const useGetActivityTypes = () => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.report.activity_types],
    queryFn: () =>
      reportService.activityTypes().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
